// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ExpertiseBadge_wrapper__3tuOR","selected":"ExpertiseBadge_selected__2JBwT","icon":"ExpertiseBadge_icon__3TJoY"};